'use client';
import React from 'react';
import { Impression } from '@benzinga/analytics';
import { ArticlePageContext } from '../../context';

interface OptimizelyCampaignifyBlockProps {
  placeholderId: string;
  nodeID: string;
  noSnippet?: boolean;
}

export const OptimizelyCampaignifyBlock: React.FC<OptimizelyCampaignifyBlockProps> = ({
  nodeID,
  noSnippet = true,
  placeholderId,
}) => {
  const article = React.useContext(ArticlePageContext);

  if (article?.hide) return null;

  return (
    <Impression campaign_id={`${placeholderId} ${nodeID}`} unit_type="Optimizely Campaignify Unit">
      <div
        className={`bz-optimizely-campaign bz-optimizely-campaign-${placeholderId}-${nodeID}`}
        data-nosnippet={noSnippet ? true : null}
      />
    </Impression>
  );
};
